module.exports = {
  API_URL: "http://localhost:5000",
  statuses: ["Pending", "Paid", "UnPaid", "Cancelled"],
  countries: ["USA", "Canada", "Eritrea", "Ethiopia", "Uganda", "Sudan"],
  currencies: ["Nakfa", "Shillings", "Birr", "USD"],
};
